
import React, { Component } from 'react';
import './Contact.css';
import propic from "../Images/propic.jpeg"
import linkSvg from "../Images/linkedin.gif"
import github from "../Images/github.gif"
import mail from "../Images/mail.gif"
import phone from "../Images/phone.gif"
export default class ContactUs extends Component {
   render (){
    return (
        <section id='contact'>
            <div  className="contact">
                
                    <div className="contactText">
                        <h1 >Hire Me.</h1>
                        <p > Connect with me via :</p>
                    </div>
                <div className='contactdiv'>
                    <div className='contactCard'>
                        <div className='linkDiv'>
                            <img id='linkimg' src={phone} alt=""></img>
                            <h2><strong>+91 - 976 465 002 2</strong></h2>   
                        </div>
                        <div className='linkDiv'>
                            <img id='linkimg' src={github} alt=""></img>
                            <h2><a href="https://github.com/umeshyadavrocks"><strong>https://github.com/umeshyadavrocks</strong></a></h2>
                        </div>
                        <div className='linkDiv'>
                            <img id='linkimg' src={mail} alt=""></img>
                            <h2><strong>umeshramyadav7771@gmail.com</strong></h2>     
                        </div>
                        <div className='linkDiv'>
                            <img id='linkimg' src={linkSvg} alt=""></img>
                            <h2><a href="https://www.linkedin.com/in/umesh-yadav-618256b6/"><strong>https://www.linkedin.com/in/umesh-yadav-618256b6/</strong></a></h2>      
                        </div>    
                    </div>
                            <div className="propic">
                                <img src={propic} alt="" className="contact__img" />
                            </div>
                </div>
            </div>
            </section>
    )
}
}
